<app-loader></app-loader>
<div class="ui-g ui-g-nopad device-height">
  <app-sidebar role="navigation" class="sidebar ui-g-12 ui-md-3 left-panel ui-g-nopad"></app-sidebar>
  <div class="main-panel ui-g-12 ui-md-9 right-panel ui-g-nopad">
    <app-header class="top-nav ui-g ui-g-nopad" role="banner"></app-header>
    <div class="inner-container" role="main">
      <app-page-header></app-page-header>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>